var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvailableFilters = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "40px",
    viewBox: "0 0 42 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "B841652D-E6A7-4C93-A437-2286834EE34C")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-768.000000, -546.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(299.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-4",
    transform: "translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(0.100000, 0.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(157.000000, 52.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-star_rate"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\uD83D\\uDD39-Icon-Color",
    points: "21 30.6086957 33.985 40 29.015 24.8347826 42 15.6521739 26.075 15.6521739 21 0 15.925 15.6521739 0 15.6521739 12.985 24.8347826 8.015 40"
  }))))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvailableFilters, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Available_Filters.2008ee75.svg";
export { ForwardRef as ReactComponent };